import { render } from "./DarkToggleMode.vue?vue&type=template&id=460b0567&scoped=true"
import script from "./DarkToggleMode.vue?vue&type=script&lang=js"
export * from "./DarkToggleMode.vue?vue&type=script&lang=js"

import "./DarkToggleMode.vue?vue&type=style&index=0&id=460b0567&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460b0567"]])

export default __exports__